<template>
  <div>
    <div class="innerItem">
      <p class="innerTitle setLabel">{{locale.logo}}<span class="stkr stkrGrey">{{locale[responsive]}}</span></p>
      <div v-if="site.logo === ''">
        <input type="file" id="uploadLogo" @change="uploadLogo($event)">
        <label for="uploadLogo" class="btn toUppercase">{{locale.upload}}</label>
      </div>
      <div v-else class="bgThumb">
        <img :src="site.logo" alt="">
        <button type="button" class="delThumb" @click="deleteLogo"><img src="~@/assets/img/ico_close.svg" alt=""></button>
      </div>
    </div>
    <div class="innerItem">
      <p class="innerTitle setLabel">{{locale.header}}/{{locale.menu}}<span class="stkr stkrGrey">{{locale[responsive]}}</span></p>
      <div v-show="!menuState && responsive !== 'tablet'" class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_color_headerbg}}</span>
          <ColorPicker class="mt5" :target="'headerBg'" :color="colors.headerBg" />
        </div>
        <div v-if="responsive !== 'tablet'" class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_color_menubtn}}</span>
          <ColorPicker class="mt5" :target="'menuBtn'" :color="colors.menuBtn" />
        </div>
        <div v-else class="flexInner"></div>
      </div>
      <div v-show="!menuState && responsive !== 'tablet'" class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_img_headerbg}}</span>
          <div v-if="imgs.headerBg && imgs.headerBg !== ''" class="bgThumb mt5">
            <img :src="imgs.headerBg" alt="">
            <button type="button" class="delThumb" @click="deleteImage('headerBg')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
          </div>
          <div v-else>
            <input type="file" id="uploadBgImg" @change="uploadImage($event, 'headerBg')">
            <label for="uploadBgImg" class="btn toUppercase mt5">{{locale.upload}}</label>
          </div>
        </div>
        <div class="flexInner">
          <div v-if="imgs.headerBg && imgs.headerBg !== ''">
            <div>
              <span class="label toCapitalize colorGrey">{{locale.editor_setting_repeat}}</span>
              <div data-item="4" class="radioItems mt5">
                <div :class="{radioItem: true, active: imgs.headerBgRepeat === 'no-repeat'}">
                  <input type="radio" name="header_background_repeat" id="header_background_repeat_n" value="no-repeat" v-model="imgs.headerBgRepeat">
                  <label for="header_background_repeat_n">{{locale.none}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgRepeat === 'repeat-x'}">
                  <input type="radio" name="detail_background_repeat" id="header_background_repeat_x" value="repeat-x" v-model="imgs.headerBgRepeat">
                  <label for="header_background_repeat_x">{{locale.editor_setting_repeat_x}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgRepeat === 'repeat-y'}">
                  <input type="radio" name="detail_background_repeat" id="header_background_repeat_y" value="repeat-y" v-model="imgs.headerBgRepeat">
                  <label for="header_background_repeat_y">{{locale.editor_setting_repeat_y}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgRepeat === 'repeat'}">
                  <input type="radio" name="detail_background_repeat" id="header_background_repeat_xy" value="repeat" v-model="imgs.headerBgRepeat">
                  <label for="header_background_repeat_xy">{{locale.editor_setting_repeat_xy}}</label>
                </div>
              </div>
            </div>
            <div class="mt10">
              <span class="label toCapitalize colorGrey">{{locale.editor_setting_size}}</span>
              <div class="radioItems mt5">
                <div :class="{radioItem: true, active: imgs.headerBgSize === 'auto'}">
                  <input type="radio" name="header_background_size" id="header_background_size_auto" value="auto" v-model="imgs.headerBgSize">
                  <label for="header_background_size_auto">{{locale.editor_setting_size_original}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgSize === 'cover'}">
                  <input type="radio" name="header_background_size" id="header_background_size_cover" value="cover" v-model="imgs.headerBgSize">
                  <label for="header_background_size_cover">{{locale.editor_setting_size_cover}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgSize === 'contain'}">
                  <input type="radio" name="header_background_size" id="header_background_size_contain" value="contain" v-model="imgs.headerBgSize">
                  <label for="header_background_size_contain">{{locale.editor_setting_size_contain}}</label>
                </div>
              </div>
            </div>
            <div class="mt10">
              <span class="label toCapitalize colorGrey">{{locale.editor_setting_position}}</span>
              <div class="radioItems mt5">
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '0 0'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_0" value="0 0" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_0"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '50% 0'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_1" value="50% 0" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_1"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '100% 0'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_2" value="100% 0" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_2"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '0 50%'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_3" value="0 50%" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_3"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '50% 50%'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_4" value="50% 50%" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_4"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '100% 50%'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_5" value="100% 50%" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_5"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '0 100%'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_6" value="0 100%" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_6"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '50% 100%'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_7" value="50% 100%" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_7"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.headerBgPosition === '100% 100%'}">
                  <input type="radio" name="header_background_pos" id="header_background_pos_8" value="100% 100%" v-model="imgs.headerBgPosition">
                  <label for="header_background_pos_8"></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="menuState && responsive !== 'tablet'" class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_color_open_dimm}}</span>
          <ColorPicker class="mt5" :target="'dimm'" :color="colors.dimm" />
        </div>
        <div v-if="responsive !== 'tablet'" class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_color_open_menubtn}}</span>
          <ColorPicker class="mt5" :target="'menuBtn2'" :color="colors.menuBtn2" />
        </div>
        <div v-else class="flexInner"></div>
      </div>
      <div v-show="menuState || responsive === 'tablet'" class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_img_menubg}}</span>
          <div v-if="imgs.menuBg && imgs.menuBg !== ''" class="bgThumb mt5">
            <img :src="imgs.menuBg" alt="">
            <button type="button" class="delThumb" @click="deleteImage('menuBg')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
          </div>
          <div v-else>
            <input type="file" id="uploadMenuImg" @change="uploadImage($event, 'menuBg')">
            <label for="uploadMenuImg" class="btn toUppercase mt5">{{locale.upload}}</label>
          </div>
        </div>
        <div class="flexInner">
          <div v-if="imgs.menuBg && imgs.menuBg !== ''">
            <div>
              <span class="label toCapitalize colorGrey">{{locale.editor_setting_repeat}}</span>
              <div data-item="4" class="radioItems mt5">
                <div :class="{radioItem: true, active: imgs.menuBgRepeat === 'no-repeat'}">
                  <input type="radio" name="menu_background_repeat" id="menu_background_repeat_n" value="no-repeat" v-model="imgs.menuBgRepeat">
                  <label for="menu_background_repeat_n">{{locale.none}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgRepeat === 'repeat-x'}">
                  <input type="radio" name="detail_background_repeat" id="menu_background_repeat_x" value="repeat-x" v-model="imgs.menuBgRepeat">
                  <label for="menu_background_repeat_x">{{locale.editor_setting_repeat_x}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgRepeat === 'repeat-y'}">
                  <input type="radio" name="detail_background_repeat" id="menu_background_repeat_y" value="repeat-y" v-model="imgs.menuBgRepeat">
                  <label for="menu_background_repeat_y">{{locale.editor_setting_repeat_y}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgRepeat === 'repeat'}">
                  <input type="radio" name="detail_background_repeat" id="menu_background_repeat_xy" value="repeat" v-model="imgs.menuBgRepeat">
                  <label for="menu_background_repeat_xy">{{locale.editor_setting_repeat_xy}}</label>
                </div>
              </div>
            </div>
            <div class="mt10">
              <span class="label toCapitalize colorGrey">{{locale.editor_setting_size}}</span>
              <div class="radioItems mt5">
                <div :class="{radioItem: true, active: imgs.menuBgSize === 'auto'}">
                  <input type="radio" name="menu_background_size" id="menu_background_size_auto" value="auto" v-model="imgs.menuBgSize">
                  <label for="menu_background_size_auto">{{locale.editor_setting_size_original}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgSize === 'cover'}">
                  <input type="radio" name="menu_background_size" id="menu_background_size_cover" value="cover" v-model="imgs.menuBgSize">
                  <label for="menu_background_size_cover">{{locale.editor_setting_size_cover}}</label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgSize === 'contain'}">
                  <input type="radio" name="menu_background_size" id="menu_background_size_contain" value="contain" v-model="imgs.menuBgSize">
                  <label for="menu_background_size_contain">{{locale.editor_setting_size_contain}}</label>
                </div>
              </div>
            </div>
            <div class="mt10">
              <span class="label toCapitalize colorGrey">{{locale.editor_setting_position}}</span>
              <div class="radioItems mt5">
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '0 0'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_0" value="0 0" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_0"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '50% 0'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_1" value="50% 0" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_1"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '100% 0'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_2" value="100% 0" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_2"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '0 50%'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_3" value="0 50%" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_3"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '50% 50%'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_4" value="50% 50%" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_4"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '100% 50%'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_5" value="100% 50%" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_5"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '0 100%'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_6" value="0 100%" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_6"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '50% 100%'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_7" value="50% 100%" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_7"></label>
                </div>
                <div :class="{radioItem: true, active: imgs.menuBgPosition === '100% 100%'}">
                  <input type="radio" name="menu_background_pos" id="menu_background_pos_8" value="100% 100%" v-model="imgs.menuBgPosition">
                  <label for="menu_background_pos_8"></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="menuState || responsive === 'tablet'" class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_color_menubg}}</span>
          <ColorPicker class="mt5" :target="'menuBg'" :color="colors.menuBg" />
        </div>
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{ locale.menu }} {{locale.text}}</span>
          <ColorPicker class="mt5" :target="'menuText'" :color="colors.menuText" />
        </div>
      </div>
      <div v-show="responsive === 'tablet'" class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.activate}} {{ locale.menu }} {{locale.background}}</span>
          <ColorPicker class="mt5" :target="'activeMenuBg'" :color="colors.activeMenuBg" />
        </div>
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.activate}} {{ locale.menu }} {{locale.text}}</span>
          <ColorPicker class="mt5" :target="'activeMenuText'" :color="colors.activeMenuText" />
        </div>
      </div>
      <div class="flexBox mb15">
        <div class="flexInner">
          <div class="label toCapitalize colorGrey">{{ locale.setting_globalicon_type }}</div>
          <span class="checkbox radio">
            <input type="radio" name="global_icon_type" id="global_icon_type_bg" value="bg" v-model="pointcolors.globalIconType">
            <label for="global_icon_type_bg">{{ locale.background }}</label>
          </span>
          <span class="checkbox radio">
            <input type="radio" name="global_icon_type" id="global_icon_type_border" value="border" v-model="pointcolors.globalIconType">
            <label for="global_icon_type_border">{{ locale.border }}</label>
          </span>
        </div>
      </div>
      <div class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.select_language}} {{locale.background}}/{{ locale.border }}</span>
          <ColorPicker class="mt5" :target="'languageBg'" :color="pointcolors.languageBg" :pointcolors="true" />
        </div>
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.select_language}} {{locale.text}}</span>
          <ColorPicker class="mt5" :target="'languageText'" :color="pointcolors.languageText" :pointcolors="true" />
        </div>
      </div>
      <div class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.mypage}} {{locale.background}}/{{ locale.border }}</span>
          <ColorPicker class="mt5" :target="'mypageBg'" :color="pointcolors.mypageBg" :pointcolors="true" />
        </div>
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.mypage}} {{locale.text}}</span>
          <ColorPicker class="mt5" :target="'mypageText'" :color="pointcolors.mypageText" :pointcolors="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ColorPicker from '@/components/Util/ColorPicker.vue'

export default {
  name: 'SetHeader',
  props: [
    'locale',
    'colors',
    'pointcolors',
    'imgs',
    'site',
    'responsive'
  ],
  components: {
    ColorPicker
  },
  computed: {
    menuState () {
      return this.$store.getters['menu/getPreviewState']
    }
  },
  methods: {
    uploadLogo (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.$store.commit('setting/updateLogo', res.source)
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    uploadImage (e, key) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          const imgData = {
            target: key,
            value: res.source
          }
          this.$store.commit('setting/updateImg', imgData)
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteLogo () {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$store.commit('setting/updateLogo', '')
      }
    },
    deleteImage (key) {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$store.commit('setting/updateImg', { target: key, img: '' })
      }
    }
  }
}
</script>
